import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CumulativeData, CumulativeDataType, CumulativeUsage } from 'src/app/bo/hiboo/cumulativeUsage';
import { Equipment } from 'src/app/bo/equipment';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { StaticUtils } from 'src/app/utils/staticUtils';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { Exploitation } from 'src/app/bo/hiboo/exploitation';
import { Tir, TirInterface } from 'src/app/bo/tir';
import { Tools } from 'src/app/utils/tools';
import { HibooService } from 'src/app/services/hiboo/hiboo.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-hiboo-dashboard',
  templateUrl: './hiboo-dashboard.component.html',
  styleUrls: ['./hiboo-dashboard.component.scss'],
  standalone: false
})
export class HibooDashboardComponent implements OnInit {
  selectedEquipment: Equipment = undefined;
  cumulativeUsage: CumulativeUsage = new CumulativeUsage();
  exploitation: Exploitation = new Exploitation();
  tabEquipments: Equipment[] = [];
  tabTir: TirInterface[] = [];
  CumulativeDataType = CumulativeDataType;
  // StaticUtils: StaticUtils;
  selectTypeData: string[] = ["Equipments", "Blasts"];
  typeDateSelected = "Equipments";

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly http: HttpService,
    private readonly hibooService: HibooService,
    private readonly fonctionsService: FonctionsService,
    private readonly utilService: UtilisateurService,
    private readonly translate: TranslateService,
    public StaticUtils: StaticUtils
  ) {
    // this.StaticUtils = StaticUtils;
  }

  ngOnInit(): void {
    this.fonctionsService.loading_screen(true);
    this.getEquipments();
  }

  protected selectEquipment(e: Equipment, index: number, event: MouseEvent) {
    const elementId = (event.target as HTMLElement).id;
    if (elementId == "checkbox") {
      const inputElement = event.target as HTMLInputElement;
      if (inputElement.checked) {
        this.tabEquipments[index].isChecked = true;
        this.getHistoryByEquipmentSelect(e);
      } else {
        this.tabEquipments[index].isChecked = false;
        this.calcCumulativeUsage();
        this.calcExploitation();
      }

    } else {
      this.tabEquipments = this.tabEquipments.map(x => ({ ...x, isChecked: false }));

      this.tabEquipments[index].isChecked = true;
      this.selectedEquipment = e;
      this.getHistoryByEquipmentSelect(e);
    }
  }

  protected selectBlast(index: number, event: MouseEvent) {
    const elementId = (event.target as HTMLElement).id;
    if (elementId == "checkbox") {
      const inputElement = event.target as HTMLInputElement;

      if (inputElement.checked) {
        this.tabTir[index].isChecked = true;
      } else {
        this.tabTir[index].isChecked = false;
        this.calcExploitationBlast();
      }

    } else {
      this.tabTir = this.tabTir.map(x => ({ ...x, isChecked: false }));
      this.tabTir[index].isChecked = true;
    }
  }


  protected getBlasts() {

    if (this.tabTir.length > 0) return;

    this.http.get<TirInterface[]>('Sites/' + this.utilService.currentSite().siteId + '/Blasts').pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response) => {
        this.tabTir = response;
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  protected dataTypeChnage() {
    this.cumulativeUsage = new CumulativeUsage();
    this.exploitation = new Exploitation();

    this.tabTir = this.tabTir.map(x => ({ ...x, isChecked: false }));
    this.tabEquipments = this.tabEquipments.map(x => ({ ...x, isChecked: false }));

    if (this.typeDateSelected == 'Equipments') {

    } else if (this.typeDateSelected == 'Blasts') {
      this.getBlasts();
    }

  }

  private getEquipments() {
    this.hibooService.getEquipmentsBySiteId(this.utilService.currentSite().siteId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response) => {
        this.tabEquipments = response;
        this.selectedEquipment = this.tabEquipments[0];
        this.getHistoryByEquipmentSelect(this.selectedEquipment);
        this.fonctionsService.loading_screen(false);
      },
      error: () => {
        this.fonctionsService.loading_screen(false);
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  private getHistoryByEquipmentSelect(e: Equipment) {
    if (!e.externalId) return;

    const index = this.tabEquipments.findIndex(x => x.externalId == e.externalId);

    if (index > -1 && this.tabEquipments[index].usage && this.tabEquipments[index].usage.cumulativeDatas.length > 0) {
      this.calcCumulativeUsage();
      return;
    }
  }

  private calcCumulativeUsage() {
    this.cumulativeUsage = new CumulativeUsage();
    this.tabEquipments.map(x => {
      if (x.isChecked) {

        if (x.usage) {
          this.addCumulativeUsage(x.usage);
        }

      }
    })
  }

  private calcExploitation() {
    this.exploitation = new Exploitation();
    this.tabEquipments.map(x => {
      if (x.isChecked) {

        if (x.exploitation) {
          this.addExploitation(x.exploitation);
        }
      }
    })
  }


  private calcExploitationBlast() {
    this.exploitation = new Exploitation();
    this.tabTir.map(x => {
      if (x.isChecked) {

        if (x.exploitation) {
          this.addExploitation(x.exploitation);
        }
      }
    })
  }

  private addCumulativeUsage(c: CumulativeUsage) {
    const newObj = Tools.deepCopy(c);
    for (let index = 0; index < newObj.cumulativeDatas.length; index++) {
      let i = -1;
      const type: CumulativeDataType = newObj.cumulativeDatas[index].type;
      i = this.cumulativeUsage.cumulativeDatas.findIndex(x => x.type == type);
      if (i > -1) {
        this.cumulativeUsage.cumulativeDatas[i].value += newObj.cumulativeDatas[index].value;
        this.cumulativeUsage.cumulativeDatas[i].value = parseFloat(this.cumulativeUsage.cumulativeDatas[i].value.toFixed(1));
      } else {
        this.cumulativeUsage.cumulativeDatas.push(newObj.cumulativeDatas[index]);
      }
    }
  }

  private addExploitation(ex: Exploitation) {
    const newObj = Tools.deepCopy(ex);

    if (this.exploitation.operatingHours != 0) {
      this.exploitation.operatingHours += newObj.operatingHours;
    } else {
      this.exploitation.operatingHours = newObj.operatingHours;
    }

    if (this.exploitation.idleHours != 0) {
      this.exploitation.idleHours += newObj.idleHours;
    } else {
      this.exploitation.idleHours = newObj.idleHours;
    }

    if (this.exploitation.fuelUsed != 0) {
      this.exploitation.fuelUsed += newObj.fuelUsed
    } else {
      this.exploitation.fuelUsed = newObj.fuelUsed;
    }

    if (this.exploitation.co2 != 0) {
      this.exploitation.co2 += newObj.co2;
    } else {
      this.exploitation.co2 = newObj.co2;
    }

    this.exploitation.usageHours += newObj.usageHours;

    this.exploitation.operatingPercent = ((this.StaticUtils.ConvertToMinutes(this.exploitation.operatingHours) / this.StaticUtils.ConvertToMinutes(this.exploitation.operatingHours)) * 100).toFixed(2);
    this.exploitation.usagePercent = ((this.StaticUtils.ConvertToMinutes(this.exploitation.usageHours) / this.StaticUtils.ConvertToMinutes(this.exploitation.operatingHours)) * 100).toFixed(2);
    this.exploitation.idlePercent = ((this.StaticUtils.ConvertToMinutes(this.exploitation.idleHours) / this.StaticUtils.ConvertToMinutes(this.exploitation.operatingHours)) * 100).toFixed(2);
    this.exploitation.hourlyConsumption = (this.exploitation.fuelUsed / this.exploitation.operatingHours).toFixed(2);
  }


  protected checkboxEquipment(e: Equipment, event: any, index: number) {


  }

  protected checkboxBlasts(t: Tir, event: any, index: number) {
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.checked) {
      this.tabTir[index].isChecked = true;
    } else {
      this.tabTir[index].isChecked = false;
      this.calcExploitationBlast();
    }
  }

  protected enumToString(enumValue: any) {
    return CumulativeData[enumValue];
  }

  protected addStringNumbers(numStr1: string, numStr2: string): string {
    // Convert the strings to numbers
    const num1 = parseFloat(numStr1);
    const num2 = parseFloat(numStr2);

    // Perform the addition
    let result = num1 + num2;

    result = parseFloat(result.toFixed(2));
    // Convert the result back to a string
    return result.toString();
  }


  protected formatDateToISO8601(date: Date, isStart: boolean): string {

    let time: string = isStart ? '0' : '59';

    // Get the date components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, time);
    const minutes = String(date.getMinutes()).padStart(2, time);
    const seconds = String(date.getSeconds()).padStart(2, time);

    // Construct the ISO 8601 string
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
  }


  private stringToEnum<T>(enumObj: T, value: string): T[keyof T] | undefined {
    return (Object.values(enumObj) as string[]).includes(value) ? value as T[keyof T] : undefined;
  }


  private deepCopy<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  }

  getDateFormat(): string {
    return StaticUtils.getDatePickerDateFormat(this.translate.currentLang);
  }

  getDateWithTimeFormat(): string {
    return StaticUtils.getDateWithTimeFormat(this.translate.currentLang);
  }
}
